function Dashboard() {
  return (
    <div>
      <h2>Welcome to the Rice Distribution Dashboard 🚀</h2>
      <p>This is a protected route. You are logged in.</p>
    </div>
  );
}

export default Dashboard;
